"use client";

import { Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function CourseDetailsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-12 gap-8 py-28 px-6 max-w-7xl mx-auto">
        <div className="col-span-12 md:col-span-8 space-y-4">
          {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-5 rounded-none bg-muted animate-pulse" />)}
        </div>
        <div className="col-span-12 md:col-span-4">
          <div className="h-64 bg-muted animate-pulse border border-border" />
        </div>
      </div>;
  }
  if (error) {
    return <div className="py-28 px-6 text-center text-muted-foreground font-default">
        Impossibile caricare i dettagli del corso.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-28 px-6 text-center text-muted-foreground font-default">
        Nessun corso disponibile.
      </div>;
  }
  const post = posts[0];
  const specs = [{
    label: "Durata",
    value: post.customFields?.wvc_corso_duration || ""
  }, {
    label: "Destinatari",
    value: post.customFields?.wvc_corso_recipients || ""
  }, {
    label: "Modalità di erogazione",
    value: post.customFields?.wvc_corso_delivery_method || ""
  }];
  return <div className="grid grid-cols-12 gap-8 lg:gap-12 py-28 px-6 max-w-7xl mx-auto">
      {}
      <div className="col-span-12 md:col-span-8">
        <h1 className="font-default text-3xl font-bold text-foreground mb-6 tracking-normal" style={{
        letterSpacing: "var(--tracking-normal)"
      }}>
          {post.customFields?.wvc_corso_title || 'Corso senza titolo'}
        </h1>

        {post.excerpt && <p className="font-sans text-base text-secondary leading-relaxed mb-6">
            <span dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />
          </p>}

        {post.customFields?.wvc_corso_content ? <div className="font-sans text-base font-normal text-foreground leading-7 space-y-4" style={{
        fontFamily: "var(--font-sans)"
      }}>
            <p className="whitespace-pre-wrap">{post.customFields.wvc_corso_content}</p>
          </div> : post.content ? <div className="font-sans text-base font-normal text-foreground leading-7 prose max-w-none" dangerouslySetInnerHTML={{
        __html: post.content
      }} /> : <p className="font-sans text-muted-foreground italic">
            Descrizione del corso non disponibile.
          </p>}

        <div className="mt-8">
          <Link to={post.link || "#"}>
            <Button variant="default" size="lg" className="rounded-none font-default font-semibold">
              Visualizza Corso Completo
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="col-span-12 md:col-span-4">
        <div className="border border-border bg-card" style={{
        borderWidth: "1px",
        borderStyle: "solid"
      }}>
          {}
          <div className="px-6 py-5 border-b border-border">
            <h2 className="font-default text-xs font-bold tracking-widest uppercase" style={{
            fontFamily: "var(--font-mono)",
            color: "var(--secondary)",
            letterSpacing: "0.1em"
          }}>
              Scheda Tecnica
            </h2>
          </div>

          {}
          <div className="px-6 py-2">
            {specs.map((spec, i) => <div key={spec.label} data-index={i}>
                <div className="py-5">
                  <p className="text-xs font-bold uppercase mb-2" style={{
                fontFamily: "var(--font-mono)",
                color: "var(--secondary)",
                letterSpacing: "0.08em"
              }}>
                    {spec.label}
                  </p>
                  <p className="font-sans text-sm font-bold text-foreground leading-snug" style={{
                fontFamily: "var(--font-sans)"
              }}>
                    {spec.value || <span className="text-muted-foreground font-normal italic">N/D</span>}
                  </p>
                </div>
                {i < specs.length - 1 && <Separator orientation="horizontal" className="bg-border" style={{
              height: "1px"
            }} />}
              </div>)}
          </div>

          {}
          <div className="px-6 py-5 border-t border-border" style={{
          borderTopWidth: "1px"
        }}>
            <Button variant="outline" size="default" className="w-full rounded-none border border-border bg-transparent font-default font-medium text-foreground hover:bg-muted">
              <Download className="mr-2 size-4" />
              Scarica il Programma
            </Button>
          </div>
        </div>
      </div>
    </div>;
}
export default function CourseDetails() {
  const wp_query_params = {
    post_type: "corso",
    per_page: 1,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="course-details" className="bg-background">
      <PostsProvider wp_query={{
      post_type: "corso",
      per_page: 1,
      order: "desc",
      orderby: "date"
    }}>
        <CourseDetailsConsumer />
      </PostsProvider>
    </section>;
}